<template>
  <div class="is-main">
    <main>
      <article>
        <section>
          <div id="firebaseui-auth-container"></div>
        </section>
        <section>
          <div id="loader">Loading...</div>
        </section>
      </article>
    </main>
  </div>
</template>

<script>
import auth from "@/store/Auth_API.js";

import "firebaseui/dist/firebaseui.css";
import firebaseui from "firebaseui";
import { firebase_auth } from "../store/Fire_Base_API";
import firebase from "firebase/app";

export default {
  name: "login",
  data: function() {
    return {};
  },
  methods: {
    go_to_ivent: function() {
      this.$router.push({
        name: "Ivent"
      });
    },
    // 遷移してきた時にチェックする
    is_Login_Already: function() {
      let loggedin = auth.get_Login_Status();

      loggedin.then(
        () => {
          this.$router.push({
            name: "Ivent_Home"
          });
        },
        () => {}
      );
    },
    login_With_Ui: function() {
      let ui = firebaseui.auth.AuthUI.getInstance();
      if (!ui) {
        ui = new firebaseui.auth.AuthUI(firebase_auth);
      }

      var config = {
        callbacks: {
          signInSuccessWithAuthResult: function() {
            return true;
          },
          signInFailure: function() {},
          uiShown: function() {
            // The widget is rendered.
            // Hide the loader.
            document.getElementById("loader").style.display = "none";
          }
        },
        // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
        signInSuccessUrl: "/ivent",
        signInFlow: "popup",
        signInOptions: [
          // Leave the lines as is for the providers you want to offer your users.
          firebase.auth.GoogleAuthProvider.PROVIDER_ID
        ]
      };

      ui.start("#firebaseui-auth-container", config);
    }
  },
  mounted: function() {
    this.is_Login_Already();
    this.login_With_Ui();
  }
};
</script>
<style>
.is-main {
  flex: 1;
}

.full-width {
  min-width: 100%;
}
</style>
